var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-contain"},[_c('div',{staticClass:"text"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.brief)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }